<template>
  <a href="#" v-on:click="onClick">
    <div class="c-filters__button c-filters__button--icon" v-on:click="toggleClass" :class="[isActive ? 'is-active' : '']"></div>
  </a>
</template>

<style lang="scss">

</style>

<script>
export default {
  name: 'Filters',
  props: {
    onClick: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      isActive: false,
    }
  },
  methods: {
    toggleClass() {
      this.isActive = !this.isActive
    },
  },
}
</script>
